module.exports = __webpack_public_path__ + "img/part-2-1.0658a1cc.webp";